export enum EditVehiculeCheckTab {
  INFOS = 'infos',
  CUSTOMER = 'customer',
  VEHICULE = 'vehicule',
}

export enum ViewVehiculeCheckTab {
  INFOS = 'infos',
  CLIENT = 'client',
  VIDEOS = 'videos',
  DETAILED_RESULTS = 'detailedResults',
  PHOTOS = 'photos',
}

export enum EditRequestVehiculeCheckTab {
  INFOS = 'infos',
  EMAILS_SENT = 'emailsSent',
}
